export const list = {
  table: {
    id: '順番',
    no: '洗浄プログラムNo.',
    name: '洗浄プログラム名',
    customer: '会社名',
    volume: '洗浄量/%',
    cost: '洗浄費(1w)/円',
    time: '洗浄時間/分',
    washingTime: '洗浄時間',
    timeUnit: '分',
    water: '水量/l',
  },
  pageHeader: {
    title: '洗浄プログラムリスト　TOP',
    new: '新規',
  },
}
